import React, {type FunctionComponent} from "react"
import LoginForm from "@App/Components/LoginForm";
import {useDispatch} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {actionCreators} from "@App/state";
import {AuthService} from "@App/apis/rest/ayvens/auth/authService";

export type LoginProps = {
    onSuccessfulLogin: () => void
}

export const Login: FunctionComponent<LoginProps> = ({onSuccessfulLogin}: LoginProps) => {
    const dispatch = useDispatch();
    const {setUserId} = bindActionCreators(actionCreators, dispatch)

    const attemptLogin = async (email: string, password: string): Promise<null | {
        emailError?: string;
        passwordError?: string;
    }> => {
        const authService = new AuthService(window.rest_url);

        try {
            const userId = await authService.login(email, password);
            setUserId(userId)
            onSuccessfulLogin?.()
            return null
        } catch (error) {
            return {emailError: error.message, passwordError: error.message}
        }
    }

    return (
        <div className={"min-h-screen"}>
            <LoginForm onSubmit={attemptLogin}/>
        </div>
    );
}
